export const state = {
    loading: false
};



// WEBPACK FOOTER //
// ./src/store/state.js